import React, { useState } from "react";
import { BARS } from "./helpers";

const TH = {
  color: "var(--muted)", fontWeight: 700, fontSize: 9,
  textTransform: "uppercase", letterSpacing: ".04em",
};

/**
 * SigRef — collapsible signal reference table.
 * Shows bars → level tag → open-air distance → enclosed distance.
 */
export default function SigRef() {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ marginBottom: 10 }}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        style={{
          width: "100%", padding: "7px 12px",
          background: "var(--card)", border: "1px solid var(--border)",
          borderRadius: 8, color: "var(--muted)", fontSize: 10,
          fontWeight: 600, cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "space-between",
        }}
      >
        <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
          {/* Mini bar icon */}
          <span style={{ display: "flex", alignItems: "flex-end", gap: 1, height: 10 }}>
            {[1, 2, 3, 4, 5, 6].map(b => (
              <span key={b} style={{
                width: 2, height: 1.5 + b * 1.4,
                background: b <= 4 ? "#22c55e" : "var(--border)",
                borderRadius: 0.5,
              }} />
            ))}
          </span>
          Referencia señal detector
        </span>
        <span style={{ transform: open ? "rotate(180deg)" : "", transition: "transform .2s", fontSize: 8 }}>▼</span>
      </button>

      {open && (
        <div style={{
          marginTop: 3, padding: 8,
          background: "var(--card)", border: "1px solid var(--border)",
          borderRadius: 8, animation: "slideUp .15s",
        }}>
          <div style={{ display: "grid", gridTemplateColumns: "44px 1fr 60px 60px", gap: "3px 8px", fontSize: 10 }}>
            <div style={TH}>Barras</div>
            <div style={TH}>Nivel</div>
            <div style={TH}>Abierto</div>
            <div style={TH}>Techado</div>
            {BARS.map(b => (
              <React.Fragment key={b.n}>
                <div style={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  {[1, 2, 3, 4, 5, 6].map(i => (
                    <span key={i} style={{
                      width: 3, height: 1.5 + i * 1.8,
                      background: i <= b.n ? b.c : "var(--border)",
                      borderRadius: 1,
                    }} />
                  ))}
                </div>
                <div style={{ color: b.c, fontWeight: 600 }}>{b.tag}</div>
                <div style={{ color: "var(--text)", fontFamily: "var(--mono)" }}>{b.open}</div>
                <div style={{ color: "var(--subtle)", fontFamily: "var(--mono)" }}>{b.closed}</div>
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
